import { store } from '@/store';
import api from '.';
import { AUTH_TOKEN } from '@/constants';

store.subscribe((mutation) => {
  console.log(mutation);
  switch (mutation.type) {
    case 'LOGIN_USER':
      if (mutation.payload) {
        api.defaults.headers.common[
          'Authorization'
        ] = `Bearer ${mutation.payload.token}`;
        localStorage.setItem(AUTH_TOKEN, mutation.payload.token);
      } else {
        api.defaults.headers.common['Authorization'] = null;
        localStorage.removeItem(AUTH_TOKEN);
      }
      break; // 🔧 FIXED: Added break to prevent fall-through

    case 'SET_TOKEN':
      if (mutation.payload) {
        api.defaults.headers.common[
          'Authorization'
        ] = `Bearer ${mutation.payload}`;
        localStorage.setItem(AUTH_TOKEN, mutation.payload);
      } else {
        api.defaults.headers.common['Authorization'] = null;
        localStorage.removeItem(AUTH_TOKEN);
      }
      break;
  }
});
